const destinations = [
  { flag: "🇲🇴", country: "Macau SAR", city: "Macau", desc: "Bossier City casino industry executives travel to Macau for gaming regulatory meetings, technology conferences, and property development partnerships. The gaming-to-gaming connection is one of Bossier's most frequent travel routes.", popular: true },
  { flag: "🇸🇬", country: "Singapore", city: "Singapore", desc: "Major gaming compliance conferences and regional casino industry summits draw Bossier City professionals to Singapore. Marina Bay Sands and Resorts World Sentosa are key industry benchmarks.", popular: true },
  { flag: "🇬🇧", country: "United Kingdom", city: "London", desc: "UK Gambling Commission regulatory events, LSUHSC physician CME conferences, and Barksdale contractor business travel. Heathrow from SHV/DFW with easy connections.", popular: true },
  { flag: "🇩🇪", country: "Germany", city: "Frankfurt & Munich", desc: "Gaming technology expos (ICE Trading, ICE London/Frankfurt) and European casino equipment trade shows attract Bossier City industry professionals annually.", popular: false },
  { flag: "🇰🇷", country: "South Korea", city: "Seoul & Osan", desc: "Barksdale AFB military personnel frequently PCS to Osan Air Base. Families need current passports and children's passports for overseas assignments.", popular: false },
  { flag: "🇯🇵", country: "Japan", city: "Tokyo & Misawa", desc: "Barksdale AFB personnel receive assignments to Misawa Air Base and Kadena Air Base. Japan is one of the most common overseas PCS destinations from Barksdale.", popular: false },
];

export default function BossierCityDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Where Bossier City Travels</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Top International Destinations from Bossier City
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From Barksdale AFB PCS orders to casino industry conferences and medical CME travel, here are the most common international destinations for Bossier City and Shreveport-Bossier metro travelers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {destinations.map((d, i) => (
            <div key={i} className={`rounded-lg border p-5 flex flex-col hover:border-[#F6C344] transition-all ${d.popular ? "bg-[#F7F8FA] border-gray-200" : "bg-white border-gray-200"}`}>
              <div className="flex items-center gap-3 mb-3">
                <span className="text-3xl">{d.flag}</span>
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{d.city}</p>
                  <p className="text-gray-400 text-xs">{d.country}</p>
                </div>
                {d.popular && <span className="ml-auto text-xs font-bold text-[#F6C344] bg-[#F6C344]/10 px-2 py-0.5 rounded-full whitespace-nowrap">Top Pick</span>}
              </div>
              <p className="text-gray-500 text-sm leading-relaxed flex-1">{d.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}